'use client';
import React from 'react';
import { CloseContainer } from '@benzinga/ui';
import { Impression } from '@benzinga/analytics';
import { MoneyBlocks } from '../MoneyBlocks';
import type { WordpressPost, Block } from '@benzinga/content-manager';
import { getScrollRevealShellClassName } from './scrollRevealShellClassName';
import { useScrollReveal } from './useScrollReveal';

export interface FloatingBlocksProps {
  post?: WordpressPost | null;
  blocks?: Block[];
}

export const FloatingBlocks: React.FC<FloatingBlocksProps> = ({ blocks, post }) => {
  const { handleOnClose, isRevealed } = useScrollReveal();

  return (
    <div className={getScrollRevealShellClassName(isRevealed, 'blocks')}>
      <Impression campaign_id={post?.floating_widget?.id ?? post?.campaigns?.utm_action} unit_type="Floating Blocks">
        <CloseContainer onClose={handleOnClose}>
          <MoneyBlocks blocks={blocks} className="floating-blocks" post={post} type="floating-widget" />
        </CloseContainer>
      </Impression>
    </div>
  );
};
